import { Button } from '@material-ui/core';
import { AddShoppingCart, RemoveShoppingCart } from '@material-ui/icons';
import React, { useMemo } from 'react';
import { TaskEntity } from '../../secure-portal/tasks/Task.interface';
import { getCartIndex, useCartContext } from './CartContext';

const CartToggleButton: React.FC<{ taskEntity: TaskEntity }> = ({
  taskEntity
}) => {
  const { cart, addToCart, removeFromCart } = useCartContext();
  const isInCart = useMemo(() => {
    return getCartIndex(cart, taskEntity) > -1;
  }, [cart, taskEntity]);
  return (
    <Button
      variant='outlined'
      color='primary'
      className='cart-button'
      onClick={event => {
        event.stopPropagation();
        if (isInCart) {
          removeFromCart(taskEntity);
        } else {
          addToCart(taskEntity);
        }
      }}
    >
      {isInCart ? <RemoveShoppingCart /> : <AddShoppingCart />}
    </Button>
  );
};

export default CartToggleButton;
